import { StandardQuizQuestion } from '@/types/quizTypes';

export const LOAD_TESTING_QUIZ: StandardQuizQuestion[] = [
  {
    id: "load-test-1",
    question: "What is the primary purpose of load testing?",
    options: [
      "Find security vulnerabilities",
      "Determine how a system performs under expected load",
      "Test user interface design",
      "Check code quality"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Load testing simulates expected user load to verify the system can handle normal and peak traffic while maintaining acceptable performance levels.",
    category: "load-testing",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "load-test-2",
    question: "What is the difference between load testing and stress testing?",
    options: [
      "No difference",
      "Load tests normal capacity, stress tests beyond capacity to find breaking point",
      "Load is faster",
      "Stress is cheaper"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Load testing validates performance under expected conditions. Stress testing pushes the system beyond normal capacity to identify breaking points and failure modes.",
    category: "testing-types",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "load-test-3",
    question: "What does 'concurrent users' mean in load testing?",
    options: [
      "Total registered users",
      "Number of users actively using the system simultaneously",
      "Users per hour",
      "Maximum database connections"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Concurrent users are those actively using the system at the same time. This differs from total users or users per hour, focusing on simultaneous active sessions.",
    category: "metrics",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "load-test-4",
    question: "What is a ramp-up period in load testing?",
    options: [
      "Testing duration",
      "Time taken to gradually increase load to target level",
      "Server startup time",
      "Database backup time"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Ramp-up gradually increases virtual users over time (e.g., 0 to 1000 users over 5 minutes) to simulate realistic traffic growth and avoid overwhelming the system instantly.",
    category: "test-configuration",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "load-test-5",
    question: "What is throughput in load testing?",
    options: [
      "CPU usage",
      "Number of transactions processed per unit time",
      "Memory consumption",
      "Network bandwidth"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Throughput measures how many transactions or requests the system processes per second/minute. Higher throughput indicates better performance capacity.",
    category: "metrics",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "load-test-6",
    question: "What are popular load testing tools?",
    options: [
      "Excel and Word",
      "JMeter, Gatling, K6, Locust",
      "Photoshop and Illustrator",
      "Chrome DevTools only"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Apache JMeter, Gatling, K6, and Locust are popular load testing tools that simulate multiple users and measure system performance under load.",
    category: "tools",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "load-test-7",
    question: "What is spike testing?",
    options: [
      "Regular load testing",
      "Suddenly increasing load to extreme levels to test recovery",
      "Security testing",
      "Database testing"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Spike testing suddenly increases load to extreme levels (like Black Friday traffic surge) to verify the system can handle sudden traffic spikes and recover gracefully.",
    category: "testing-types",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "load-test-8",
    question: "What is the 90th percentile response time?",
    options: [
      "Average response time",
      "90% of requests complete faster than this time",
      "Maximum response time",
      "Minimum response time"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "The 90th percentile (p90) means 90% of requests were faster than this value. It's better than average for understanding real user experience as it filters out outliers.",
    category: "metrics",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateLoadTestingQuiz = () => ({
  questions: LOAD_TESTING_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'load-testing'
});
